import { useMemo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { STATIC_FILTERS } from '../components/Filters/Filters.content';
import { selectCategories, selectCategoryIds } from '../state';
import { Filter } from '../components/Filters/Filters.types';

const useFilters = () => {
  const categories = useSelector(selectCategories);
  const categoriesById = useSelector(selectCategoryIds);

  return useMemo(
    () => [
      ...STATIC_FILTERS,
      ...categoriesById
        .filter((id) => categories[id].showOnLobby || !categoriesById[id])
        .map<Filter>((id) => ({
          id,
          locKey: categories[id].title,
          onPress: (navigation) =>
            navigation.navigate('CategoryDetailsScreen', { id }),
          gamesCount: categories[id].games.length,
        })),
    ],
    [categories, categoriesById],
  );
};

export default useFilters;
